import { render, staticRenderFns } from "./FundDetail.vue?vue&type=template&id=19738422&scoped=true&"
import script from "./FundDetail.vue?vue&type=script&lang=js&"
export * from "./FundDetail.vue?vue&type=script&lang=js&"
import style0 from "./FundDetail.vue?vue&type=style&index=0&id=19738422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19738422",
  null
  
)

export default component.exports